import { Button, Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import useTranslate from '../../../../../../i18n/useTranslate'
import useSign from './useSign'
import { ButtonClose, ButtonSign } from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import { memorandumTopic } from '../../../../../../constants/constants'
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../../constants/submittedStep'

export type SignREC2ViewType = ReturnType<typeof useSign>
const SignREC1View = (props: SignREC2ViewType) => {
    const {
        onRefDialog,
        configDialog,

        isViewMode,
        isNotShowSign,
        initialMemorandumFile,
        initialValues,
        handleDirtyChange,
        onClickBackToSearch,
        onSubmitForm,
        initialMemorandumFileSign,
        projectData,
    } = props

    const translate = useTranslate()
    const btn = (props: any) => {
        if (!isViewMode && !isNotShowSign) {
            return (
                <ButtonSign
                    onClickSave={() => {
                        props.form.change('saveType', 'SAVE')
                        props.handleSubmit()
                    }}
                />
            )
        } else {
            if (!isViewMode) {
                return <ButtonClose onClickClose={onClickBackToSearch} />
            }
        }
    }
    //มีการลงนามไปแล้ว
    const isSignMemoMessage: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                memorandumFile: initialMemorandumFile,
                memorandumFileSign: initialMemorandumFileSign,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                return (
                    <>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    name={'memorandumFile'}
                                    initialData={initialMemorandumFile}
                                    documentTitleList={memorandumTopic}
                                    title={translate.get('LABEL.MEMO_MESSAGE_DOC')}
                                    isViewMode={true}
                                    disabledBtn={true}
                                />
                            </Grid>
                            {isSignMemoMessage && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        name={'memorandumFileSign'}
                                        initialData={initialMemorandumFileSign}
                                        documentTitleList={memorandumTopic}
                                        title={translate.get('LABEL.MEMO_MESSAGE_DOC_SIGN')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                        // onClickOpenFile={onClickOpenFile}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {btn(props)}

                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}
export type SignREC2Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const SignREC2 = (props: SignREC2Type) => {
    const signREC2 = useSign(props)
    return <SignREC1View {...signREC2} />
}

export default SignREC2
